<H1>Alpaca's
  <button mat-raised-button 
  class="button-primary-action" 
  routerLink="/admin/alpaca/add"
  style="float:right;"
  >Nieuwe alpaca</button>
</H1>

<div class="table-toolbar">
  <mat-form-field>
    <mat-label>Filter op naam</mat-label>
    <input matInput (keyup)="applySearchByNameFilter($event)" placeholder="Zoeken" #input>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Status Filter</mat-label>
    <mat-select [(value)]="selectedStatuses" multiple (selectionChange)="applyStatusFilter($event)">
      @for (status of statuses; track status) {
      <mat-option [value]="status">{{status}}</mat-option>
      }
    </mat-select>
  </mat-form-field>

<mat-form-field>
  <mat-label>Category Filter</mat-label>
  <mat-select [(value)]="selectedCategories" multiple (selectionChange)="applyCategoryFilter($event)">
    @for (category of categories; track category) {
    <mat-option [value]="category">{{category}}</mat-option>
    }
  </mat-select>
</mat-form-field>
</div>

<app-http-loader [componentId]="componentId">
<div>
  <table mat-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="shortName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Naam </th>
      <td mat-cell *matCellDef="let element"> {{element.shortName}} </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
      <td mat-cell *matCellDef="let element"> {{element.status}} </td>
    </ng-container>
    <ng-container matColumnDef="category">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Category </th>
      <td mat-cell *matCellDef="let element"> {{element.category}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
    class="row-hover-highlight" 
    [routerLink]="['/admin/alpacas/', row.id, 'edit']"></tr>
  
  </table>

  <mat-paginator 
  showFirstLastButtons
  [pageSizeOptions]="[5, 10, 20]"
  [pageSize]="10"
  aria-label="Select page">
  </mat-paginator>
</div>
</app-http-loader>